import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import "./style/bootstrap.min.css";
import "./style/style.css";
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';

import SiteLogin from "./components/login";
import ForgotPassword from "./components/forgot";
import ResetPassword from "./components/reset";
import SiteLogout from "./components/logout";
import SiteRegister from "./components/register";
import SiteRegisterPro from "./components/register_pro";
import AffiliateDashboard from "./components/dashboard";

class App extends Component {
  render() {
    return (
  

    <Routes>
      <Route path="/" element={<AffiliateDashboard/>} />
      <Route path="/signin" element={<SiteLogin/>} />
      <Route path="/reset-password" element={<ResetPassword/>} />
      <Route path="/forgot-password" element={<ForgotPassword/>} />
      <Route path="/register" element={<SiteRegisterPro/>} />
      <Route path="/sign-up" element={<SiteRegister/>} />
      <Route path="/dashboard" element={<AffiliateDashboard/>} />
      <Route path="/logout" element={<SiteLogout/>} />
    </Routes>
);
  }
}

export default App;
